import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from "@/layouts/MainLayout.vue";
import MainPage from "@/views/main-page.vue";
import PolicyPage from "@/views/policy-page.vue";

const routes = [
  {
    path: '/policy',
    name: 'policy',
    component: PolicyPage,
  },
  {
    path: '/',
    name: 'home',
    component: MainLayout,
    children: [
      {
        path: '/',
        name: 'main',
        component: MainPage,
      },
      {
        path: '/about',
        name: 'about',
        component: MainPage,
      },
      {
        path: '/catalog',
        name: 'catalog',
        component: MainPage,
      },
      {
        path: '/service',
        name: 'service',
        component: MainPage,
      },
      {
        path: '/career',
        name: 'career',
        component: MainPage,
      },
      {
        path: '/case',
        name: 'case',
        component: MainPage,
      },
      {
        path: '/material',
        name: 'material',
        component: MainPage,
      },
      {
        path: '/history',
        name: 'history',
        component: MainPage,
      },
      {
        path: '/advantages',
        name: 'advantages',
        component: MainPage,
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return false
  },

})

export default router
